import React, { useState } from 'react'

import { useInView } from 'react-cool-inview'

import { array, bool, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import { printModelsPath } from 'Pods/Shared/paths'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import BudgetSection from './components/categories/BudgetSection'
import CategoryList from './components/categories/CategoryList'
import SectionHeader from './components/categories/SectionHeader'

function NewPrintCategoriesSection({ itemCategories = EMPTY_ARRAY, budgetCounter = EMPTY_ARRAY, extractingCoreStyles = false, locale = 'en' }) {
  const [hasObserved, setHasObserved] = useState(false)
  const { observe, inView } = useInView({
    rootMargin: '200px',
    unobserveOnEnter: true,
  })

  const categorySectionTitle = i18n.t('printModelPage.categorySectionTitle', { ns: 'rails', lng: locale })
  const categorySectionDescription = i18n.t('printModelPage.categorySectionDescription', { ns: 'rails', lng: locale })
  const categorySectionButtonText = i18n.t('printModelPage.categorySectionButtonText', { ns: 'rails', lng: locale })
  const categorySectionBadgeText = i18n.t('printModelPage.categorySectionBadgeText', { ns: 'rails', lng: locale })
  const buttonHref = printModelsPath(locale)
  const renderCategoriesContent = () => (
    <div className="categories-section__main-content">
      <div className="categories-section__filters">
        <SectionHeader
          title={categorySectionTitle}
          description={categorySectionDescription}
          buttonText={categorySectionButtonText}
          buttonHref={`${buttonHref}?page=1`}
          badgeText={categorySectionBadgeText}
        />

        <BudgetSection
          budgetItems={budgetCounter}
          promoItems={{ freeItems: budgetCounter[3].itemCount, onSale: budgetCounter[4].itemCount }}
          locale={locale}
        />
      </div>

      <CategoryList categories={itemCategories} locale={locale} />
    </div>
  )

  return (
    <section
      className="categories-section"
      ref={(element) => {
        if (!hasObserved) {
          setHasObserved(true)
          observe(element)
        }
      }}
    >
      {(inView || extractingCoreStyles) && renderCategoriesContent()}
    </section>
  )
}

NewPrintCategoriesSection.propTypes = {
  itemCategories: array,
  budgetCounter: array,
  extractingCoreStyles: bool,
  locale: string,
}

export default NewPrintCategoriesSection
